if (!customElements.get('pdp-media-gallery')) {
  customElements.define(
    'pdp-media-gallery',
    class PdpMediaGallery extends HTMLElement {
      connectedCallback() {
        this.enableZoom = this.dataset.enableZoom === 'true';
        if (this.enableZoom) {
          this.initZoom();
        }
        this.initResponsiveLayout();
      }

      // Mobile shows a single main image with everything else -- including the
      // desktop-only secondary hero images -- as thumbnails in the breadcrumb
      // slider below. Moves nodes (not clones) so no image is fetched twice.
      initResponsiveLayout() {
        const heroSecondary = this.querySelector('.pdp-gallery__hero-secondary');
        const thumbs = this.querySelector('.pdp-gallery__thumbs');
        if (!heroSecondary || !thumbs) return;

        const secondaryItems = [...heroSecondary.children];
        if (!secondaryItems.length) return;

        const mql = window.matchMedia('(max-width: 767.98px)');
        const sync = () => {
          if (mql.matches) {
            secondaryItems.forEach((item) => item.classList.add('pdp-gallery__thumb'));
            thumbs.prepend(...secondaryItems);
          } else {
            secondaryItems.forEach((item) => item.classList.remove('pdp-gallery__thumb'));
            heroSecondary.append(...secondaryItems);
          }
        };
        mql.addEventListener('change', sync);
        sync();
      }

      initZoom() {
        const items = [...this.querySelectorAll('[data-pdp-media-item]')];
        if (!items.length || !window.FoxTheme || !window.FoxTheme.PhotoSwipeLightbox) return;

        const dataSource = items.map((item) => {
          switch (item.dataset.mediaType) {
            case 'model':
              return {
                id: item.dataset.mediaIndex,
                html: `<div class="pswp__item--${item.dataset.mediaType}">${
                  item.querySelector('product-model').outerHTML
                }</div>`,
                mediaType: item.dataset.mediaType,
              };
            case 'video':
            case 'external_video':
              return {
                id: item.dataset.mediaIndex,
                html: `<div class="pswp__item--${item.dataset.mediaType}">${
                  item.querySelector('video-element').outerHTML
                }</div>`,
                mediaType: item.dataset.mediaType,
              };
            default:
              return {
                id: item.dataset.mediaIndex,
                src: item.dataset.src,
                width: item.dataset.pswpWidth,
                height: item.dataset.pswpHeight,
                mediaType: 'image',
              };
          }
        });

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType !== 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (items.length > 1) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: () => this.lightbox.pswp.next(),
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: () => this.lightbox.pswp.prev(),
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: () => this.lightbox.pswp.close(),
          });
        });

        this.lightbox.init();

        this.addEventListener('click', (e) => {
          const trigger = e.target.closest('[data-pdp-media-item]');
          if (!trigger || trigger.dataset.mediaType !== 'image') return;
          e.preventDefault();
          const index = Number(trigger.dataset.mediaIndex) || 0;
          this.lightbox.loadAndOpen(index);
        });
      }
    }
  );
}
